module.exports = __webpack_public_path__ + "img/grey_042.9c025d9f.png";